export const AUTH_COOKIE_NAME = 'auth_token'

/**
 * How long the auth cookie outlives its access token: the API's refresh window
 * (`JWT_REFRESH_TTL`, 14 days), so an expired token can still be refreshed.
 */
export const AUTH_SESSION_MAX_AGE = 60 * 60 * 24 * 14

/**
 * Clear token cookie (client-side only)
 */
export function clearTokenCookie() {
  if (typeof document === 'undefined') return
  document.cookie = `${AUTH_COOKIE_NAME}=; Path=/; Max-Age=0`
}

/**
 * Get token from cookie (client-side only)
 */
export function getTokenFromCookie(): null | string {
  const match = document.cookie.match(new RegExp(`${AUTH_COOKIE_NAME}=([^;]+)`))
  return match ? decodeURIComponent(match[1]) : null
}

/**
 * Set token cookie (client-side only)
 */
export function setTokenCookie(token: string, maxAge: number = AUTH_SESSION_MAX_AGE) {
  if (typeof document === 'undefined') return
  const secure = process.env.NODE_ENV === 'production' ? '; Secure' : ''
  document.cookie = `${AUTH_COOKIE_NAME}=${encodeURIComponent(token)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}
